import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { Observable } from "rxjs";
import { Folio } from "src/app/models/Folio/Folio";
import { TipoDte } from "src/app/models/tipoDte";
import { FoliosService } from "src/app/services/folios.service";
import { LocalStorageService } from "src/app/services/local-storage.service";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { UtilitiesService } from "src/app/services/utilities.service";

@Component({
   selector: "app-folios-widget",
   templateUrl: "./folios-widget.component.html",
   styleUrls: ["./folios-widget.component.scss"],
})
export class FoliosWidgetComponent implements OnInit {
   currentEmisor: string;
   sucursalId: string;
   fullData: Folio[];
   groupedFolios: Object;
   listFolioResumen: any[] = [];
   tipoDteSource = JSON.parse(this.localStorage.getDteTypes()) as TipoDte[];
   loadingFoliosSummary$: Observable<boolean>;
   constructor(private foliosService: FoliosService, private tokenService: TokenStorageService, private localStorage: LocalStorageService, private ref: ChangeDetectorRef, private utilities: UtilitiesService) {
      this.currentEmisor = this.tokenService.getCompany();
      this.sucursalId = this.tokenService.getSubsidiary();
      this.loadingFoliosSummary$ = this.foliosService.isLoadingFolios;
   }

   ngOnInit(): void {
      if (this.currentEmisor) {
         this.foliosService.getData(this.currentEmisor, this.sucursalId).subscribe(
            (res) => {
               this.fullData = res.data;
               this.groupedFolios = this.groupArrayOfObjects(this.fullData, "tipoDteId");
               //foreach tipoDteId sum foliosDisponibles y vencimiento mas cercano
               for (const tipoDteGroup of Object.entries(this.groupedFolios)) {
                  let sumOfDteType = 0;
                  if (tipoDteGroup != null && tipoDteGroup.length > 0) {
                     (tipoDteGroup[1] as any[]).forEach((currentObj) => {
                        if (currentObj["activo"]) {
                           sumOfDteType += currentObj["foliosDisponibles"];
                        }
                     });
                  }
                  tipoDteGroup["suma"] = sumOfDteType;
                  tipoDteGroup["nombre"] = this.getDteTypeName(tipoDteGroup[0]);
                  this.listFolioResumen.push(tipoDteGroup);
                  this.ref.detectChanges();
                  this.utilities.sortAlphabeth(this.listFolioResumen, "nombre");
               }

               //pass name of DteTypes
            },
            (err) => {}
         );
      }
   }

   getDteTypeName(dteTypeId): string {
      return this.tipoDteSource.find((type) => type.tipoDteId == dteTypeId).nombre;
   }
   groupArrayOfObjects(list, key) {
      return list.reduce(function (rv, x) {
         (rv[x[key]] = rv[x[key]] || []).push(x);
         return rv;
      }, {});
   }
}
